import React from "react";
// import Card from "react-bootstrap/Card";
// import Card from "../Card/Card";
// import { Link } from "react-router-dom";
import "./Footer.css"
import { FaFacebookF } from "react-icons/fa";
import { FaDollyFlatbed } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
function Footer() {
    return (
        <footer>
            <div class="container ">
                <div className="footer_links">
               <a href="#">WHOE WE ARE</a>|
               <a href="#">CONTACT US</a>|

               <a href="#">WHOE WE ARE</a>|
               <a href="#">CONTACT US</a>|
               <a href="#">LOOKBOOK</a>|
               <a href="#">ORDER CANCELLATION FORM</a>|
               <a href="#">TRACK YOUR ORDER</a>|
               <a href="#">SERVICE WE PROVIDE</a>|
               <a href="#">CAREERS</a>|
               <a href="#">LEGAL</a>|
               <a href="#">FAQ'S</a>|
               <a href="#">PRIVACY & POLICY</a>|
               
                </div>
                <div className="icons">
                    <FaDollyFlatbed className="h-dolly" />
                    <FaFacebookF className="h-facebook" />
                    <FaInstagramSquare className="h-instagram" />
                </div>
            </div>
            <div className="copy">
               ALL RIGHT RESERVED TO BAROQUE 2023
               </div>
        </footer>
    );
}

export default Footer;